import { takeEvery, put, call } from 'redux-saga/effects';
import { AuthActions } from '../../actions/constant';
import authService from '../../../services/apiServices/authService';
import { SagaReturnType } from 'redux-saga/effects';

const { REQUEST_SET_PASSWORD, SUCCESS_SET_PASSWORD, FAILURE_SET_PASSWORD } =
  AuthActions;

function* setPassword(action: any): SagaReturnType<any> {
  try {
    const response = yield call(authService.setPassword, action.payload);
    if (response?.status === 200 || response?.status === 201) {
      yield put({
        type: SUCCESS_SET_PASSWORD,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_SET_PASSWORD, payload: error });
  }
}

function* setPasswordSaga() {
  yield takeEvery(REQUEST_SET_PASSWORD, setPassword);
}

export default setPasswordSaga;
